/* eslint-disable max-lines-per-function */
import EventClass from "common/utils/ui/event-class";

import "./product-details-upload-button-static.scss";

class ProductDetailsUploadButtonStatic extends EventClass {
  #frontUploadSelector = "#field-artwork-upload-front";

  #uploadButton = ".js-product-details-upload-button-static";

  #designLabMyDeviceBtn = ".js-my-device-btn";

  #signInButton = ".js-sign-in-modal-toggle";

  #artworkExists = false;

  #eventCaller = null;

  get $uploadButton() {
    return document.querySelector(this.#uploadButton);
  }

  get $referenceUploadButton() {
    return (
      document.querySelector(this.#signInButton) ||
      document.querySelector(this.#designLabMyDeviceBtn) ||
      document.querySelector(this.#frontUploadSelector)
    );
  }

  event(e) {
    super.event(e);
    this.#eventCaller = e.currentTarget;
    this.$referenceUploadButton.setAttribute("data-trigger", "hero_image");
    this.$referenceUploadButton.setAttribute("data-trigger-text", e.target.textContent.trim());
    this.$referenceUploadButton.click();
  }

  init() {
    return this;
  }

  toggleButtonsVisibility() {
    const uploadButtonShown = !this.#artworkExists;
    this.$uploadButton.classList.toggle("hidden", !uploadButtonShown);
  }
}

export default () =>
  new ProductDetailsUploadButtonStatic({
    eventSelector: ".js-product-details-upload-button-static"
  });
